import React from "react";
import { Navbar } from "@components/Navigation/Navbar";
import { StatusTrackerV2Provider } from "./StatusTrackerV2Provider";
import { FilterBar } from "./containers/FilterBar";
import { StatusTrackerGrid } from "./containers/StatusTrackerGrid";
import { TaggingModeBanner } from "./containers/TaggingModeBanner";
import { CellDetailModal } from "./containers/CellDetailModal";
import "./styles/styles-StatusTrackerV2.css";

const StatusTrackerV2Inner = ({ isEmbedded, legendLeading }) => (
    <>
        {!isEmbedded && <Navbar />}
        <div className="stv2-tracker-container">
            <div className="stv2-tracker-header">
                {!isEmbedded && <FilterBar />}
                <TaggingModeBanner />
            </div>
            <StatusTrackerGrid legendLeading={legendLeading} flagTooltipPlacement={isEmbedded ? "top" : "right"} />
            <CellDetailModal />
        </div>
    </>
);

// Entry point. Self-contained: own provider/state/api/styles, reads team config from Redux
// read-only. `externalFilters` and `onUnavailable` are for an embedding page — see the provider.
// `legendLeading` slots a node at the head of the status legend; an embedding page puts its
// month picker there, the way the V1 tracker did, since embedded mode has no filter bar.
export const StatusTrackerV2 = ({ isEmbedded = false, externalFilters, onUnavailable, legendLeading }) => (
    <StatusTrackerV2Provider externalFilters={externalFilters} onUnavailable={onUnavailable}>
        <StatusTrackerV2Inner isEmbedded={isEmbedded} legendLeading={legendLeading} />
    </StatusTrackerV2Provider>
);

export default StatusTrackerV2;
